import { Bar } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import { useLazyDownloadPatientsAgesQuery, usePatientsAgesQuery } from 'store/api';
import 'chart.js/auto';
import { Button } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

interface ChartData {
	labels: string[];
	datasets: {
		label: string;
		data: number[];
		backgroundColor: string[];
		borderColor: string;
		borderWidth: number;
	}[];
}

export const AgeDataChart = () => {
	const { data: ageData, isLoading, error } = usePatientsAgesQuery(null, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
    });
	const [trigger, { isFetching }] = useLazyDownloadPatientsAgesQuery();

	const [chartData, setChartData] = useState<ChartData>({
		labels: [],
		datasets: [
			{
				label: 'Распределение клиентов по возрастам',
				data: [],
				backgroundColor: [],
				borderColor: 'rgba(75, 192, 192, 1)',
				borderWidth: 1,
			},
		],
	});

	useEffect(() => {
		if (ageData) {
			const labels: string[] = [];
			const data: any[] = [];
			const backgroundColors: any[] = [];

			ageData?.forEach((item, index) => {
				labels.push(item.ageGroup);
				data.push(item.count);
				backgroundColors.push(`rgba(${255 - index * 50}, ${192 - index * 20}, ${192 - index * 20}, 0.2)`);
			});

			setChartData({
				labels: labels,
				datasets: [
					{
						label: 'Распределение пациентов по возрастам',
						data: data,
						backgroundColor: backgroundColors,
						borderColor: 'rgba(75, 192, 192, 1)',
						borderWidth: 1,
					},
				],
			});
		}
	}, [ageData]);

	const options = {
		scales: {
			y: {
				beginAtZero: true,
				title: {
					display: true,
					text: 'Количество пациентов',
				},
			},
			x: {
				title: {
					display: true,
					text: 'Возрастные группы',
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
		},
	}; // Зависимость от ageData для перерисовки при изменении

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчет клиентов по возрастам.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};
	return (
		<div className={styles.chart}>
			<h2>Распределение пациентов по возрастам</h2>
			<Bar data={chartData} options={options} />
			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт клиентов по возрастам'}
			</Button>
		</div>
	);
};
